import { computed } from 'vue';

export function useChannelIcon(inbox) {
  const channelTypeIconMap = {
    'Channel::Api': 'i-woot-api',
    'Channel::Email': 'i-woot-mail',
    'Channel::FacebookPage': 'i-woot-messenger',
    'Channel::Line': 'i-woot-line',
    'Channel::Sms': 'i-woot-sms',
    'Channel::Telegram': 'i-woot-telegram',
    'Channel::TwilioSms': 'i-woot-sms',
    'Channel::TwitterProfile': 'i-woot-x',
    'Channel::WebWidget': 'i-woot-website',
    'Channel::Whatsapp': 'i-woot-whatsapp',
    'Channel::Instagram': 'i-woot-instagram',
    'Channel::Tiktok': 'i-woot-tiktok',
    'Channel::Voice': 'i-woot-voice',
  };

  const providerIconMap = {
    microsoft: 'i-woot-outlook',
    google: 'i-woot-gmail',
  };

  const salesSecretIconMap = {
    sales_secret_facebook: 'i-woot-messenger',
    sales_secret_instagram: 'i-woot-instagram',
    sales_secret_whatsapp: 'i-woot-whatsapp',
    sales_secret_tiktok: 'i-woot-tiktok',
    sales_secret_openphone: 'i-woot-sms',
    sales_secret_twilio: 'i-woot-sms',
    sales_secret_webchat: 'i-woot-website',
  };

  const channelIcon = computed(() => {
    const inboxDetails = inbox.value || inbox;
    const type = inboxDetails.channel_type;
    let icon = channelTypeIconMap[type];

    if (type === 'Channel::Email' && inboxDetails.provider) {
      if (Object.keys(providerIconMap).includes(inboxDetails.provider)) {
        icon = providerIconMap[inboxDetails.provider];
      }
    }

    // Special case for Twilio whatsapp
    if (type === 'Channel::TwilioSms' && inboxDetails.medium === 'whatsapp') {
      icon = 'i-woot-whatsapp';
    }

    // Special case for Sales Secret API channels — match by identifier or name
    if (type === 'Channel::Api') {
      const identifier = inboxDetails.inbox_identifier || '';
      const name = (inboxDetails.name || '').toLowerCase();

      if (salesSecretIconMap[identifier]) {
        icon = salesSecretIconMap[identifier];
      } else if (
        name.includes('quo') ||
        name.includes('openphone') ||
        name.includes('sms')
      ) {
        icon = 'i-woot-sms';
      } else if (
        name.includes('fb') ||
        name.includes('facebook') ||
        name.includes('messenger')
      ) {
        icon = 'i-woot-messenger';
      } else if (
        name.includes('webchat') ||
        name.includes('web chat') ||
        name.includes('widget')
      ) {
        icon = 'i-woot-website';
      } else if (name.includes('instagram') || name.includes('ig')) {
        icon = 'i-woot-instagram';
      } else if (name.includes('whatsapp') || name.includes('wa')) {
        icon = 'i-woot-whatsapp';
      }
    }

    return icon ?? 'i-ri-global-fill';
  });

  return channelIcon;
}
